import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

import { CanUseService, Feature } from '@app/shared/can-use.service';

export const canOrgGuard = (feature: Feature, redirectToOnFailure = '/'): CanActivateFn => {
  return (): Observable<UrlTree | boolean> => {
    const canUseService = inject(CanUseService);
    const router = inject(Router);

    return toObservable(canUseService.initialized).pipe(
      filter((v) => v),
      take(1),
      map(() => (canUseService.can(feature) ? true : router.parseUrl(redirectToOnFailure))),
    );
  };
};
